module.exports = __webpack_public_path__ + "img/header-bg.5b2cf804.jpg";